<script>
    /*
        This is a quick test to see if I can get the audio recording working via Svelte in the
        browser. It does! (in Chrome which I tested). Code from:
        - https://cptcrunchy.medium.com/how-to-build-a-voice-recorder-with-sveltekit-d331e3e94af6
        - https://github.com/cptcrunchy/sound-board/blob/main/src/routes/index.svelte
     */

    import { onMount, createEventDispatcher } from 'svelte'

    const dispatch = createEventDispatcher();

    let media = [];
    let mediaRecorder = null;
    let chosen_mimetype = 'audio/webm;codecs="opus"'; // Android/Google Chrome
    onMount(async () => {
        if(!MediaRecorder.isTypeSupported(chosen_mimetype)) {
            chosen_mimetype = 'audio/mp4'; // iOS
        }

        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        mediaRecorder = new MediaRecorder(stream, {
            audioBitsPerSecond: 128000,  // 128 Khz
            mimeType: chosen_mimetype
            // mimeType: 'audio/webm'
            // mimeType: 'audio/webm;codecs=vorbis'
            // mimeType: `audio/mp4; codecs="mp4a.40.1"`  // NB this codec doesn't work in Chrome
        });
        mediaRecorder.ondataavailable = (e) => media.push(e.data)
        mediaRecorder.onstop = function(){
            console.log(mediaRecorder.mimeType); // TODO handle this mimetype rather than hardcoding below?
            // const blob = new Blob(media, {'type' : 'audio/webm; codecs=opus' });
            // const blob = new Blob(media, {'type' : mediaRecorder.mimeType });
            const blob = new Blob(media, {'type' : chosen_mimetype });
            // const blob = new Blob(media, {'type' : `audio/mp4; codecs="mp4a.40.1"` });  // NB this codec doesn't work in Chrome
            media = []; // <-- We reset our media array

            // dispatch('voicenote', {audio: blob, mime_type: mediaRecorder.mimeType});
            dispatch('voicenote', {audio: blob, mime_type: chosen_mimetype});
        }
    })

    const UI_STATES = {
        READY: 1,
        IS_RECORDING: 2,
        FINISHED: 3,
    };
    let ui_state = UI_STATES.READY;

    // NB method for the parent component to indicate when we can reset the ui_state once the data is finished sending etc
    export let sending = false;
    $: {
        if(!sending) {
            ui_state = UI_STATES.READY;
        }
    }
    const toggleState = () => {
        switch(ui_state) {
            case UI_STATES.READY:
                mediaRecorder.start();
                ui_state = UI_STATES.IS_RECORDING;
                break;
            case UI_STATES.IS_RECORDING:
                mediaRecorder.stop();
                ui_state = UI_STATES.FINISHED;
                break;
            case UI_STATES.FINISHED:
                // ..do nothing, the parent component will change the `sending` var to reset to the initial state
                break;
        }
    };

</script>

<section>
    {#if ui_state === UI_STATES.READY}
        <button on:click={toggleState}
                type="submit"
                class="inline-flex items-center justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        ><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 18.75a6 6 0 006-6v-1.5m-6 7.5a6 6 0 01-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 01-3-3V4.5a3 3 0 116 0v8.25a3 3 0 01-3 3z" />
        </svg>
        </button>
    {/if}
    {#if ui_state === UI_STATES.IS_RECORDING}
        <button on:click={toggleState}
                type="submit"
                class="inline-flex items-center justify-center rounded-md border border-transparent bg-green-600 px-2 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        ><svg class="self-center w-5 h-5 mr-2" viewBox="0 0 135 140" xmlns="http://www.w3.org/2000/svg" fill="#fff">
            <rect y="10" width="15" height="120" rx="6">
                <animate attributeName="height"
                         begin="0.5s" dur="1s"
                         values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear"
                         repeatCount="indefinite" />
                <animate attributeName="y"
                         begin="0.5s" dur="1s"
                         values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear"
                         repeatCount="indefinite" />
            </rect>
            <rect x="30" y="10" width="15" height="120" rx="6">
                <animate attributeName="height"
                         begin="0.25s" dur="1s"
                         values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear"
                         repeatCount="indefinite" />
                <animate attributeName="y"
                         begin="0.25s" dur="1s"
                         values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear"
                         repeatCount="indefinite" />
            </rect>
            <rect x="60" width="15" height="140" rx="6">
                <animate attributeName="height"
                         begin="0s" dur="1s"
                         values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear"
                         repeatCount="indefinite" />
                <animate attributeName="y"
                         begin="0s" dur="1s"
                         values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear"
                         repeatCount="indefinite" />
            </rect>
            <rect x="90" y="10" width="15" height="120" rx="6">
                <animate attributeName="height"
                         begin="0.25s" dur="1s"
                         values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear"
                         repeatCount="indefinite" />
                <animate attributeName="y"
                         begin="0.25s" dur="1s"
                         values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear"
                         repeatCount="indefinite" />
            </rect>
            <rect x="120" y="10" width="15" height="120" rx="6">
                <animate attributeName="height"
                         begin="0.5s" dur="1s"
                         values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear"
                         repeatCount="indefinite" />
                <animate attributeName="y"
                         begin="0.5s" dur="1s"
                         values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear"
                         repeatCount="indefinite" />
            </rect>
        </svg>
            Stop</button>
    {/if}
    {#if ui_state === UI_STATES.FINISHED}
        <button type="submit"
                class="inline-flex items-center justify-center rounded-md border border-transparent bg-orange-600 px-2 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        ><svg class="animate-spin self-center w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
        </svg>
            Sending..</button>
    {/if}
</section>

<style></style>